export default __webpack_public_path__ + "b237f100ebb28cb8ed63a1eaf01490c6.png";